import { render, staticRenderFns } from "./UserForOpenbadgeV3Page.vue?vue&type=template&id=174aca66"
import script from "./UserForOpenbadgeV3Page.vue?vue&type=script&lang=js"
export * from "./UserForOpenbadgeV3Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports